<template>
  <div class="waiter-area">
    <div class="row justify-content-center">
      <div class="col-2 p-0" v-for="(place, index) in places" :key="index">
        <div class="card-item">
          <!-- <Card /> -->

          <!-- Use above card component for integration. 
          Below lines are used for a demo purpose-->

          <!-- Demo Code -->
          <div
            id="summary"
            :class="{
                          allocated: place.selected
                        }"
            @click="SelectPlace(place)"
          >
            <strong>{{ place.name}}</strong>
            <!-- <em>Table1</em> -->
            <!-- <small>Pimpilikka pilaappi</small> -->
          </div>
          <!-- Demo Code -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "@/plugins/axios";
import("./style.css");

export default {
  name: "PlaceList",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedCustomer: {
      type: Object,
      default: {},
    },
    selectedPlace: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    places: [],
  }),
  watch: {
    visible: function (value) {
      if (!value) {
        this.selected = 0;
      }
    },
  },

  created: function () {
    this.GetAllDishes();
  },
  methods: {
    async GetAllDishes() {
      let url = "hms/web/places";
      axios
        .get(url)
        .then((res) => {
          console.log("Placesss", res);
          this.places = res.data.map((p) => {
            if (p.id == this.selectedPlace.id) {
              p.selected = true;
            } else {
              p.selected = false;
            }

            (p.id = p.id), (p.name = p.name);
            return p;
          });

          this.loaded = true;
        })
        .catch((err) => {});
    },
    SelectPlace(place) {
      place.selected = true;
      this.$emit("SelectPlace", place);
    },
  },
};
</script>